module.exports = __webpack_public_path__ + "static/media/fyfe_asbell_macaluso_brooks_reed_gonzalez_larkin_granda_permuy.607665f3.gif";